<template>
  <section class="main-nextdraws" v-bind:class="{'is-loaded' : loaded}">
    <div class="site-anchor" id="main-nextdraws"></div>
    <div class="main-nextdraws__content" v-bind:class="[lotterySelected ? 'lot-'+lotterySelected.slug+'-bg-dark' : '']">

      <div class="main-nextdraws__content__loader">
        <i class="fa fa-refresh fa-spin mr-2"></i> Carregando próximos sorteios...
      </div>

      <div class="main-nextdraws__body" v-if="loaded && lotteries && lotteries.length">

        <div class="container" v-if="loaded && lotteries && lotteries.length">
          <div class="row">
            <div class="col-12">

              <div class="head-nextdraws">
                <div class="head-nextdraws-top" v-if="!isMobile && lotterySelected" :class="{[`lot-${lotterySelected.slug}`]: true}">
                  <div class="head-nextdraws-top-name lot-color lot-bg-light">
                    {{lotterySelected.name}}
                  </div>
                  <div class="head-nextdraws-top-info">
                    <div class="lot-color">
                      <div class="inline-icon is-schedule lot-bg lot-border-light"></div>

                      <div class="head-nextdraws-top-info__label" v-if="lotterySelected.nextDraw.drawDateText === 'Hoje' || lotterySelected.nextDraw.drawDateText === 'Amanhã' || lotterySelected.special">
                        {{lotterySelected.nextDraw.drawDateText}}
                      </div>
                      <div class="head-nextdraws-top-info__label" v-else>
                        {{lotterySelected.nextDraw.drawWeekDay.split('-')[0]}}
                      </div>
                    </div>
                    <div class="lot-color">
                      <div class="inline-icon is-bag lot-bg lot-border-light"></div>
                      <div class="head-nextdraws-top-info__label">{{(lotterySelected.nextDraw.estimatedPrize !== 0 ? 'R$ ' : '' )+lotterySelected.nextDraw.estimatedPrizeText}}</div>
                    </div>
                    <div v-if="lotterySelected.nextDraw.isJackpot">
                      <div class="jackpot-icon"></div>
                      <div class="head-nextdraws-top-info__label is-jackpot">Acumulada</div>
                    </div>
                  </div>
                </div>

                <div class="head-nextdraws-lots">

                  <div
                    class="head-nextdraws__item"
                    :class="{'is-selected' : (lotterySelected.name === lottery.name), [`lot-${lottery.slug}`] : true,[`lot-${lottery.slug}-border`] : true}"
                    v-for="lottery, index in lotteries.slice(0, LIMIT)" :key="`lottery-${index}`"
                    @click="setLottery(lottery)"
                  >
                    <div class="lot-color head-nextdraws__item-name" v-if="lotterySelected.name !== lottery.name">
                      <span class="head-nextdraws__item-name-block">{{lottery.acron}}</span>
                    </div>
                    <div class="lot-color head-nextdraws__item-name is-long" v-else>
                      <span class="head-nextdraws__item-name-block grid-align-icon">
                        <span>{{(lottery.name.length > 12 && lottery.shortname) ? lottery.shortname : lottery.name}}</span>
                        <span v-if="lottery.name.length > 12" class="head-nextdraws__item-jackpot-text-right"></span>
                        <span v-else class="head-nextdraws__item-jackpot-text"></span>
                      </span>
                    </div>

                    <div v-if="lottery?.nextDraw?.isJackpot" class="head-nextdraws__item-jackpot">Acumulada</div>
                  </div>

                </div>

              </div>

            </div>

            <div class="col-12">
              <div class="main-nextdraws__header">
                <h2 class="main-nextdraws__header__title">Aumente suas chances apostando online nas <strong>loterias</strong></h2>
              </div>

              <div class="main-nextdraws-selected" v-if="isMobile && lotterySelected" :class="{[`lot-${lotterySelected.slug}`]: true}">

                <div class="main-nextdraws-selected-top" :class="{'is-jackpot' : lotterySelected.nextDraw.isJackpot }">
                  <div class="main-nextdraws-selected-name lot-color lot-bg-light">
                    {{lotterySelected.name}}
                  </div>
                  <div class="main-nextdraws-selected-jackpot" v-if="lotterySelected.nextDraw.isJackpot">
                    <div class="jackpot-icon"></div>
                    <div class="main-nextdraws-selected-info__label is-jackpot">Acumulada</div>
                  </div>
                </div>

                <div class="main-nextdraws-selected-info">
                  <div class="lot-color">
                    <div class="inline-icon is-schedule lot-bg lot-border-light"></div>

                    <div class="main-nextdraws-selected-info__label" v-if="lotterySelected.nextDraw.drawDateText === 'Hoje' || lotterySelected.nextDraw.drawDateText === 'Amanhã' || lotterySelected.special">
                      {{lotterySelected.nextDraw.drawDateText}}
                    </div>
                    <div class="main-nextdraws-selected-info__label" v-else>
                      {{lotterySelected.nextDraw.drawWeekDay.split('-')[0]}}
                    </div>
                  </div>
                  <div class="lot-color">
                    <div class="inline-icon is-bag lot-bg lot-border-light"></div>
                    <div class="main-nextdraws-selected-info__label">{{(lotterySelected.nextDraw.estimatedPrize !== 0 ? 'R$ ' : '' )+lotterySelected.nextDraw.estimatedPrizeText}}</div>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-12">
              <div class="main-nextdraws__cards__wrap" v-if="lotterySelected">

                <div class="boloes-slider-card__wrap" v-if="products">
                  <tiny-slider v-bind="tinySliderOptions" ref="tinySlider">
                    <div v-for="product,index in products" :key="`boloes-slider-card-product-${index}`">
                      <card-bolao :item-data="product" :item-type="'circle'" :item-label-add-cart="getLabel(index)"></card-bolao>
                    </div>
                  </tiny-slider>
                </div>

                <div v-if="!products">
                  <div class="boloes-slider-card__message">
                    <i class="fa fa-refresh fa-spin mr-2"></i> Carregando...
                  </div>
                </div>

              </div>

            </div>

            <div class="col-12">
              <div class="main-nextdraws__lottery__footer">
                <a v-bind:href="'/'+lotterySelected.slug" class="btn btn-block btn-square text-uppercase" v-text="'Veja tudo sobre a '+lotterySelected.name"></a>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- /.main-nextdraws__columns -->
    </div>
    <!-- /.main-nextdraws__content -->
  </section>
</template>
<style src="./MainNextDraw.scss" scoped></style>
<script>
import CardBolao from '@components/BoxBoloes/CardBolao';
import VueTinySlider from 'vue-tiny-slider';
import dateDiff from '@helpers/dateDiff';
import getLotBar from '@services/inventory/getLotBar';
import getProductsById from '@services/inventory/getProductsById';
import checkIsMobile from '@helpers/isMobile';

export default {
  components: {
    'tiny-slider': VueTinySlider,
    'card-bolao': CardBolao
  },
  data () {
    return {
      loaded: false,
      isProcessing: false,
      lotteries: [],
      lotterySelected: null,
      products: null,
      cart: null,
      pendingAdd: null,
      processingCard: false,
      placeholderCount: 0,
      LIMIT: 4,
      labels: ['Garanta já!', 'Esse é meu!', 'Meu bolão da sorte!'],
      isMobile: true,
      tinySliderOptions: {
        items: 1,
        center: false,
        autoplay: false,
        edgePadding: 0,
        autoplayButtonOutput: true,
        gutter: 20,
        loop: false,
        nav: true,
        slideBy: 1,
        controlsText: ['', ''],
        responsive: {
          991: {
            items: 2
          },
          1199: {
            items: 3
          }
        }
      }
    };
  },
  methods: {
    fetchInfo () {
      if (this.isProcessing) {
        return;
      }

      getLotBar()
        .then((res) => {
          if (res && res.draws) {
            // add special lottery
            res.draws.special = [];

            const specialLottery = res.special
              ? res.special.lottery
              : null;

            if (specialLottery) {
              delete res.special.lottery;
              specialLottery.nextDraw = res.special;
              res.draws.special.push(specialLottery);
            }

            // add commons lotteries

            this.lotteries = this.getLotsList(res.draws, true);

            if (this.lotteries.length < this.LIMIT) {
              this.lotteries = this.lotteries.concat(
                this.getLotsList(res.draws, false)
              );
            }

            if (res.draws.special && res.draws.special.length) {
              this.lotteries = this.lotteries.slice(0, this.LIMIT - 1);
              const diff = dateDiff(
                new Date(res.draws.special[0].nextDraw.drawDate)
              );
              // destaque loteria especial N dias antes do sorteio:
              this.lotteries[diff <= 14 ? 'unshift' : 'push'](
                res.draws.special[0]
              );
            } else {
              this.lotteries = this.lotteries.slice(0, this.LIMIT + 1);
            }

            this.placeholderCount =
                this.lotteries.length < this.LIMIT
                  ? this.LIMIT - (this.lotteries.length + 1)
                  : 0;
          }

          this.setLottery(null, false);
          this.loaded = true;
        })
        .catch((err) => console.error(err));
    },
    getLotsList (draws, hasOffers = true) {
      let lotteries = [];

      ['today', 'tomorrow', 'next'].forEach((a) => {
        let lots = draws[a];
        if (!lots) {
          return;
        }

        lots = lots.sort((lotA, lotB) => {
          return (
            lotB.nextDraw.estimatedPrize - lotA.nextDraw.estimatedPrize
          );
        });

        lotteries = lotteries.concat(
          lots.filter((a) => {
            return (
              a.nextDraw &&
              a.nextDraw.hasProductsAvailable &&
              a.nextDraw.hasOffers == hasOffers
            );
          })
        );
      });

      return lotteries;
    },
    loadProducts () {
      if (!this.lotterySelected || this.isProcessing) {
        return;
      }

      this.isProcessing = true;
      this.products = null;

      const _self = this;

      const proms = [
        getProductsById(this.lotterySelected.id, {
          groupItems: false,
          special: this.lotterySelected.special || false
        })
      ];

      Promise.all(proms)
        .then((res) => {
          const products = res[0].products || [];
          let productsPick = [];

          if (products.length) {
            productsPick = products.filter((a) => a.isEspecialOffer);

            if (productsPick.length < 3) {
              for (let i = 0; i < products.length; i++) {
                if (!productsPick.find((a) => a.id == products[i].id)) {
                  productsPick.push(products[i]);
                }

                if (productsPick.length >= 3) {
                  break;
                }
              }
            }

            productsPick.forEach((a) => {
              a.lottery = this.lotterySelected;
              a.nextDraw = this.lotterySelected.nextDraw;
            });

            _self.products = productsPick;
          }
        })
        .catch((err) => console.error(err))
        .then(() => {
          setTimeout(() => {
            _self.isProcessing = false;
          }, 300);
        });
    },
    setLottery (lotteryObj, scroll = true) {
      if (
        (this.loaded && this.isProcessing) ||
        (lotteryObj && lotteryObj == this.lotterySelected)
      ) {
        return;
      }
      this.lotterySelected = lotteryObj || this.lotteries[0];
      if (scroll && window.innerWidth < 992) {
        setTimeout(() => {
          this.$scrollTo(document.getElementById('main-nextdraws'));
        }, 300);
      }
      this.loadProducts();
    },
    getLabel (index) {
      const i = index + 1;

      if (i % 3 == 0) {
        return this.labels[2];
      } else if (i % 2 == 0) {
        return this.labels[1];
      } else {
        return this.labels[0];
      }
    }
  },
  created () {
    this.fetchInfo();
    this.isMobile = checkIsMobile();
    window.addEventListener('resize', () => {
      this.isMobile = checkIsMobile();
    })
  }
}
</script>
